import React from 'react';
import useStyle from './tableDataTab.style';
import { classNames } from '../../../helpers/style/classNames';
import { Icon } from '../Icons';
import { FlatIcon } from '../Icons/FlatIcon';

interface TableDataTabProps {
  content: string;
  variant?: 'normal' | 'danger';
  icon?: Icon;
  onClick: () => void;
  selected: boolean;
}

export const TableDataTab = ({
  content,
  variant = 'normal',
  icon,
  onClick,
  selected = false
}: TableDataTabProps) => {
  const classes = useStyle();

  return (
    <div
      onClick={onClick}
      className={classNames([classes.root, classes[variant]], {
        condition: selected,
        classe: classes.selected
      })}
    >
      {content}
      {icon && <FlatIcon icon={icon} color={variant === 'danger' && '#FFF'} />}
    </div>
  );
};
